import { Avatar } from '@/components/ui';
import type { MemberFace } from '../api/myCommunities';

interface MemberFacePileProps {
  members: MemberFace[];
  /** Real total member count, for the "+N" overflow chip. */
  total: number;
}

/** Overlapping avatar stack — the member preview on each community card. */
export function MemberFacePile({ members, total }: MemberFacePileProps) {
  if (!members.length) return null;
  const shown = members.slice(0, 4);
  const extra = Math.max(total - shown.length, 0);

  return (
    <div className="flex items-center">
      {shown.map((m) => (
        <div key={m.id} className="-ml-2 rounded-full ring-2 ring-page first:ml-0">
          <Avatar src={m.avatarUrl} name={m.name} size={22} />
        </div>
      ))}
      {extra > 0 && (
        <div className="-ml-2 grid h-[22px] min-w-[22px] place-items-center rounded-full bg-white/10 px-1 text-[9px] font-bold text-mid ring-2 ring-page">
          +{extra}
        </div>
      )}
    </div>
  );
}
